<template>
  <div>
    <a-modal
      width="500px"
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="核库"
      @ok="handleSubmit"
    >
      <a-form
        class="simiot-compact-form"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 15 }"
        @submit="handleSubmit"
      >
        <a-form-item label="核查结果">
          <a-select
            :loading="loadingCheckStoreTypeOptions"
            show-search
            :filter-option="filterOption"
            v-decorator="[
              'check_store_type_id',
              { rules: [{ required: true, message: '请选择类型' }] },
            ]"
            placeholder="请选择"
          >
            <a-select-option
              v-for="record in checkStoreTypeOptions"
              :key="record.sub_type_slug"
              :value="record.id"
            >
              {{ record.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :label="`备注`" style="margin-top: 20px">
          <a-textarea
            v-decorator="['remark', {
              rules: [
                {required: true, message: '请填写备注'},
                { max: 200, message: '最多200个字符' },
              ]
            }]"
            :auto-size="{ minRows: 3, maxRows: 5 }"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { checkStoreAgentPreOrderItem } from '@/api/agent_pre_order_item'
import { findCommonTypeOptions } from '@/api/common_type'
export default {
  name: 'CheckStoreItem',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      remark: '',
      submitting: false,
      checkStoreTypeOptions: [],
      loadingCheckStoreTypeOptions: true,
      form: this.$form.createForm(this, { name: 'check_store_agent_pre_order_item' })
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchCheckStoreTypeOptions()
  },
  methods: {
    // 加载预制订单类型
    fetchCheckStoreTypeOptions() {
      this.loadingCheckStoreTypeOptions = true
      findCommonTypeOptions('check_store').then((res) => {
        if (res.code === 0) {
          this.checkStoreTypeOptions = res.data
        }
        this.loadingCheckStoreTypeOptions = false
      })
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          checkStoreAgentPreOrderItem(this.id, values).then((res) => {
            if (res.code === 0) {
              // 关闭模态框
              this.isShow = false
              // 告知父组件已完成
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
